// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__30SET","inputWrap":"Table_inputWrap__fcp1-","col":"Table_col__1K4gx","bmiTooltip":"Table_bmiTooltip__Ydax9"};